import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  // Full width of the Policy Actions right column, so it wraps under Add Hold Card rather than beside it;
  // alignSelf keeps the column's stretched flex line from padding the box out to the toggles' height.
  callout: {
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'flex-start',
    gap: theme.spacing(2),
    width: '100%',
    boxSizing: 'border-box',
    marginTop: theme.spacing(4),
    padding: theme.spacing(3, 4),
    border: `1px solid ${theme.colorPalette.beige_50_op_50}`,
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colors.light_background
  },
  icon: {
    flexShrink: 0,
    fontSize: 20,
    color: theme.colors.light_text
  },
  note: {
    margin: 0,
    fontSize: 14,
    lineHeight: 1.4,
    textAlign: 'left',
    color: theme.colors.light_text
  },
  // The global `a { display: contents }` gives a link no box, so its underline wouldn't draw.
  link: {
    display: 'inline',
    color: theme.colors.light_text,
    textDecoration: 'underline',
    overflowWrap: 'anywhere'
  }
});

export default makeStyles(styles);
